import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../../../../taboola-common-frontend-modules/i18n';
import TooltipSection from '../../TooltipSection';

const AdsTooltip = ({ disabled }) => {
    if (disabled) {
        return (
            <TooltipSection>
                <FormattedMessage
                    id="campaign.editor.duplicateCampaignSettings.ads.tooltip.disabled"
                    defaultMessage="These ads can't be duplicated. Once the campaign is duplicated, add new ones."
                />
            </TooltipSection>
        );
    }

    return (
        <TooltipSection
            tip={
                <FormattedMessage
                    id="campaign.editor.duplicateCampaignSettings.ads.tooltip.tip"
                    defaultMessage="select this option only if you plan to use the same (or very similar) ads in your new campaign."
                />
            }
        >
            <FormattedMessage
                id="campaign.editor.duplicateCampaignSettings.ads.tooltip.main"
                defaultMessage="Duplicate all ads from the original campaign. (Includes any related settings - e.g. campaign review status, ad review status and campaign safety rating.)"
            />
        </TooltipSection>
    );
};

AdsTooltip.propTypes = {
    disabled: PropTypes.bool,
};

export default AdsTooltip;
